import React from 'react';
import OnboardingVideos from './OnboardingVideos';

const OnboardingVideoPage: React.FC = () => {
    return (
        <div className="video-page">
            <OnboardingVideos />
        </div>
    );
};

export default OnboardingVideoPage;